
import store from '../index.js.erb'
import ScholarshipMeetingCommentApi
    from "../../../components/application/scholarship/Services/Api/MeetingApi/ScholarshipMeetingCommentApi";
import {getField, updateField} from "vuex-map-fields";
import _ from "lodash";


const ScholarshipCommentStore = {
    namespaced: true,
    state: ()=>({
        studentComments: [],

        payloadComment: {
            scholarship_competition_id: null,
            prtf_achievement_id: null,
            comment: null,
            comment_type: "not_status",
            payload: {},
        },
        dialogComment: false,
    }),

    getters: {
        getPayloadComment(state) {
            return getField(state.payloadComment);
        },
    },

    mutations: {

        updatePayloadComment(state, field) {
            updateField(state.payloadComment, field);
        },

        setDialogFlag(state, flag) {
            state.dialogComment = flag;
        },

        setCompetitionId(state, id) {
            state.payloadComment.scholarship_competition_id = id;
        },

        setAchievementId(state, id) {
            state.payloadComment.prtf_achievement_id = id;
        },

        setCommentText(state, comment) {
            state.payloadComment.comment = comment;
        },

        resetPayloadComment(state) {
            state.payloadComment = {
                scholarship_competition_id: null,
                prtf_achievement_id: null,
                comment: null,
                comment_type: "not_status",
                payload: {},
            }
        },
    },

    actions: {
        openDialog({commit}, {competitionId, achievementId}) {
            commit('setCompetitionId', competitionId);
            commit('setAchievementId', achievementId);
            commit('setDialogFlag', true);
        },

        closeDialog({commit}) {
            commit('resetPayloadComment');
            commit('setDialogFlag', false);
        },

        async createComment({state, dispatch}) {
            const achievementId = _.clone(state.payloadComment.prtf_achievement_id);
            const idMeeting = store.state.scholarship_meeting.meeting.id;
            const response = await ScholarshipMeetingCommentApi.create(idMeeting, state.payloadComment);

            if(_.isNil(response)) return null;

            await dispatch('closeDialog');

            return achievementId;
        },

        async addVoteComment({state, dispatch}, {idComment, status, comment}) {
            const idMeeting = store.state.scholarship_meeting.meeting.id;
            const response = await ScholarshipMeetingCommentApi.addVoteComment(idMeeting, idComment, status, comment);

            if(_.isNil(response)) return null;
            store.dispatch('scholarship_competition/getStatement', store.state.scholarship_competition.statement.id)
        },

        async updateVoteComment({state, dispatch}, {idComment, idVote, comment}) {
            const idMeeting = store.state.scholarship_meeting.meeting.id;
            const response = await ScholarshipMeetingCommentApi.updateVoteComment(idMeeting, idComment, idVote, comment);

            if(_.isNil(response)) return null;
            store.dispatch('scholarship_competition/getStatement', store.state.scholarship_competition.statement.id)
        },

    },
}

export default ScholarshipCommentStore